function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "#C5D1C0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.157 7H7.75v.75h6.434l-1.637 1.636.53.53 2.53-2.528-2.53-2.528-.53.53L14.157 7zm-9.75 5.263l2.529 2.529.53-.53-1.637-1.637h6.42v-.75H5.857l1.61-1.61-.53-.53-2.529 2.528z",
  fill: "#36443A",
  stroke: "#36443A",
  strokeWidth: 0.2
});

function SvgSwapIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9IiNDNUQxQzAiLz4KPHBhdGggZD0iTTE0LjE1NzEgNy4wMDAwMUw3Ljc0OTk1IDcuMDAwMDFWNy43NTAwMUwxNC4xODM4IDcuNzUwMDFMMTIuNTQ3MyA5LjM4NjQ5TDEzLjA3NzYgOS45MTY4MUwxNS42MDYxIDcuMzg4MzJMMTMuMDc3NiA0Ljg1OTg2TDEyLjU0NzMgNS4zOTAxNkwxNC4xNTcxIDcuMDAwMDFaTTQuNDA3MSAxMi4yNjMzTDYuOTM1NjEgMTQuNzkxOEw3LjQ2NTkzIDE0LjI2MTVMNS44Mjk0NiAxMi42MjVIMTIuMjQ5OVYxMS44NzVINS44NTYwOEw3LjQ2NTkzIDEwLjI2NTJMNi45MzU2MSA5LjczNDg2TDQuNDA3MSAxMi4yNjMzWiIgZmlsbD0iIzM2NDQzQSIgc3Ryb2tlPSIjMzY0NDNBIiBzdHJva2Utd2lkdGg9IjAuMiIvPgo8L3N2Zz4K";
export { SvgSwapIcon as ReactComponent };